import React, { useState, useEffect, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import {
  Nav,
  NavItem,
  TopIcon,
  Span,
  Div,
  SubNavItem,
  UL,
  ListItem,
} from "./styles";
import { FaUsers } from "react-icons/fa";
import { BsCalendar4 } from "react-icons/bs";
import { IoWalletOutline } from "react-icons/io5";
import {
  FiFilePlus,
  FiSettings,
  FiChevronRight,
  FiChevronDown,
} from "react-icons/fi";
import ScheduleNav from "./ScheduleNav";
import BillingNav from "./BillingNav";
import ReportNav from "./ReportNav.js";
import SettingsNav from "./SettingsNav";
import { MdMonitor } from "react-icons/md";
import ExploreWidget from "./ExploreWidget";
import Greaterthan from "../../assets/images/Greaterthan.png";
import Greaterthanopp from "../../assets/images/Greaterthanopp.png";
import UnLoadScripts from "../popups/unLoadScript";
import { Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import { GetNav } from "../../StateManagement/Reducers/ScheduleState";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { globalColor } from "../utils/RepeatFunctions/Schedule";
import { Popup } from "semantic-ui-react";
import GetStartedPopup from "../popups/GetStartedPopup.js";
import { getHighlightStyles } from "../setting/HighlightConstants.js";
import { setGetStarted } from "../../StateManagement/Reducers/GetStartedState.js";
const SideNav = () => {
  // ------------------------------ State and Variables start--------------------------------------------------- //
  const permission = localStorage.getItem("setroles");
  const decryptedPermission = Decrypt_Value(permission, "vozo");
  const [isOpen, setIsOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState("");
  const [showPatientSubMenu, setShowPatientSubMenu] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const timeoutRef = useRef(null);
  const navRef = useRef(null);
  const location = useLocation();

  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const location1 = useLocation();
  const history = useHistory();
  const [isIntroOpen, setIsIntroOpen] = useState(false);
  const [showStepFourIntro, setShowStepFourIntro] = useState(false);
  const navItemRef = useRef(null);
  const highlightinsclaim = useRef(null);

  // Your existing state
  const [isSettingsMainMenuOpen, setIsSettingsMainMenuOpen] = useState(false);

  const [isservicePopupOpen, setisservicePopupOpen] = useState(() => {
    return location1.state?.steponeclient || false;
  });

  var accountType =
    localStorage.getItem("account_type") &&
    Decrypt_Value(localStorage.getItem("account_type"), "vozo");

  const servicesRef = useRef(null);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const Patient_subroutes = [
    "/patient/patientdashboard/",
    "/patient/demographics/",
    "/patient/appointment/",
    "/patient/billandinsurance/",
    "/patient/documents/",
    "/patient/problems/",
    "/patient/allergies/",
    "/patient/medication/",
    "/patient/immunization/",
    "/patient/familyhistory/",
    "/patient/procedureorder/",
    "/patient/senderx/",
    "/patient/clientportalaccess/",
  ];
  const expired_days =
    localStorage.getItem("expired_days") &&
    Decrypt_Value(localStorage.getItem("expired_days"), "vozo");
  var group_id = Decrypt_Value(localStorage.getItem("group_id"), "vozo");
  var NavData1 = useSelector((state) => state.Schedule?.NavData);
  var showAdd1 = useSelector((state) => state.Revision?.showAdd1);
  var showAdd2 = useSelector((state) => state.Revision?.showAdd2);
  var Showcontact = useSelector((state) => state.Revision?.Showcontact);
  const dispatch = useDispatch();

  const storedNames =
    localStorage.getItem("setroles") &&
    Decrypt_Value(localStorage.getItem("setroles"), "vozo");

  // ------------------------------ State and Variables end---------------------------------------------------//

  // ------------------------------ Functions----start------------------------------------------------------//
  const isOnPatientDashboard = Patient_subroutes.some((path) =>
    location.pathname.includes(path)
  );
  const [isinsclaimOpen, setIsinsclaimOpen] = useState(
    location.state ? location?.state?.insclaimopen : false
  );
  // handleIntroNext
  const handleIntroNext = () => {
    dispatch(setGetStarted({ fromComponent: true }));
    setIsIntroOpen(false);
    setIsOpen(true);
    history.replace({
      pathname: "/patient/patientlist",
      search: "?step=6.2",
    });
  };

  const handleMouseEnter = () => {
    dispatch(GetNav("iconopen"));
    setIsOpen(true);
    setIsHovered(false);
    isOnPatientDashboard
      ? setShowPatientSubMenu(true)
      : setShowPatientSubMenu(false);
    if (
      (splitLocation[1] === "schedule" && splitLocation[2] === "nav") ||
      splitLocation[2] === "calender" ||
      (location.pathname === "/" && storedNames.appt)
    ) {
      setOpenSubMenu("schedule");
    } else {
      setOpenSubMenu(splitLocation[1]);
    }

    if (location.pathname === "/" && !storedNames.appt && storedNames.demo) {
      setOpenSubMenu("patient");
    } else if (
      location.pathname === "/" &&
      !storedNames.appt &&
      !storedNames.demo &&
      storedNames.bill
    ) {
      setOpenSubMenu("billing");
    } else if (
      location.pathname === "/" &&
      !storedNames.appt &&
      !storedNames.demo &&
      !storedNames.bill &&
      storedNames.rep
    ) {
      setOpenSubMenu("report");
    } else if (
      location.pathname === "/" &&
      !storedNames.appt &&
      !storedNames.demo &&
      !storedNames.bill &&
      !storedNames.rep &&
      storedNames.users
    ) {
      setOpenSubMenu("settings");
    }
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const handleClose = () => {
    dispatch(GetNav("iconclose"));
    isOnPatientDashboard && setShowPatientSubMenu(false);
    setIsOpen(false);
    setOpenSubMenu("");
  };

  const handleSubMenuClick = (menuName) => {
    setOpenSubMenu(openSubMenu === menuName ? "" : menuName);
  };

  const handleMouseEnterPatient = () => {
    setShowPatientSubMenu(true);
    setIsOpen(true);
    setOpenSubMenu("patient");
  };

  const exploreMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsHovered(true);
  };

  // Timeout to work the hover effect
  const exploreMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsHovered(false);
    }, 200);
  };
  const handleInputChange = (iconName) => (e) => {
    dispatch(GetNav(iconName));
  };
  const handleInputChange1 = (iconName) => {
    dispatch(GetNav(iconName));
  };
  const [shouldScrollToTop, setShouldScrollToTop] = useState(false);
  const scrollToTop = () => {
    setShouldScrollToTop(true);
    if (navRef.current) {
      navRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  };
  // ------------------------------ Functions----end---------------------------------------------------//

  // ------------------------------ useEffect----start---------------------------------------------------//
  useEffect(() => {
    if (isOnPatientDashboard && isOpen) {
      handleMouseEnterPatient();
      setShowPatientSubMenu(true);
    }
  }, [isOnPatientDashboard]);
  useEffect(() => {
    if (shouldScrollToTop && navRef.current) {
      navRef.current.scrollTo({ top: 0, behavior: "smooth" });
      setShouldScrollToTop(false); // Reset after scrolling
    }
  }, [shouldScrollToTop]);
  useEffect(() => {
    UnLoadScripts();
  }, []);
  useEffect(() => {
    if (NavData1 === "iconclose") {
      setIsOpen(false);
      setOpenSubMenu("");
    } else if (NavData1 === "iconopen") {
      setIsOpen(true);
      if (
        (splitLocation[1] === "schedule" && splitLocation[2] === "nav") ||
        splitLocation[2] === "calender" ||
        location.pathname === "/"
      ) {
        setOpenSubMenu("schedule");
      } else {
        setOpenSubMenu(splitLocation[1]);
      }
    }
  }, [NavData1]);
  useEffect(() => {
    const updatePopupPosition = () => {
      if (isservicePopupOpen) {
        const rect = servicesRef.current.getBoundingClientRect();
        setPopupPosition({
          top: rect.y + window.scrollY - 180, // 10px below the highlighted section
          left: rect.left + window.scrollX + 90,
        });
      }
    };

    return updatePopupPosition();
  }, [isservicePopupOpen]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const step = query.get("step");

    if (step === "6.1") {
      setIsIntroOpen(false); // 🔒 Close popup first

      setTimeout(() => {
        navRef.current?.scrollTo({
          top: 0,
          behavior: "smooth",
        });

        // ✅ Open popup after scrolling
        const openPopupDelay = setTimeout(() => {
          setIsIntroOpen(true);
        }, 200); // ⏳ Wait for smooth scroll animation to complete

        // Cleanup nested timeout
        return () => clearTimeout(openPopupDelay);
      }, 200);

      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    } else if (step === "6.4") {
      setOpenSubMenu("schedule");
      setShowStepFourIntro(true);
      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    }
  }, [location?.search]);

  useEffect(() => {
    if (location?.state?.patientportalstarted && navRef.current) {
      setIsOpen(true);
      dispatch(GetNav("iconopen"));
      setIsHovered(false);
      setOpenSubMenu("settings");
      window.scrollTo(0, 0);
      setTimeout(() => {
        navRef.current.scrollTo({
          top: 300,
          behavior: "smooth",
        });
      }, 0);
    }
  }, [location?.state?.patientportalstarted]);
  useEffect(() => {
    if (location?.state?.payerstateopen && navRef.current) {
      setIsOpen(true);
      dispatch(GetNav("iconopen"));
      setIsHovered(false);
      setOpenSubMenu("settings");
      setTimeout(() => {
        navRef.current.scrollTo({
          top: 280,
          behavior: "smooth",
        });
      }, 0);
    }
  }, [location?.state?.payerstateopen]);
  useEffect(() => {
    if (location?.state?.patientpaymentopen && navRef.current) {
      setIsOpen(true);
      dispatch(GetNav("iconopen"));
      setIsHovered(false);
      setOpenSubMenu("billing");
    }
  }, [location?.state?.patientpaymentopen]);
  useEffect(() => {
    if (location?.state?.insclaimopen && navRef.current) {
      setIsOpen(true);
      dispatch(GetNav("iconopen"));
      setIsHovered(false);
      setOpenSubMenu("billing");
    }
  }, [location?.state?.insclaimopen]);

  // useEffect(() => {
  //   if (location?.data && location.data?.serbillgetstart1 && navRef.current) {
  //     setisservicePopupOpen(true);
  //     window.scrollTo(0, 0);
  //     setTimeout(() => {
  //       navRef.current.scrollTo({
  //         top: 300,
  //         behavior: "smooth",
  //       });
  //     }, 0);
  //   }
  // }, [location?.data?.serbillgetstart1]);
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const step = query.get("step");

    if (step === "1.2") {
      setIsSettingsMainMenuOpen(true); // or whatever you want to trigger

      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    }
  }, [location.search]);
  useEffect(() => {
    if (isSettingsMainMenuOpen && navItemRef.current) {
      navItemRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center", // or "start" or "end" depending on where you want it aligned
      });
    }
  }, [isSettingsMainMenuOpen]);
  useEffect(() => {
    if (location?.state?.insclaimopen !== undefined) {
      if (location?.state?.insclaimopen === true) {
        setIsinsclaimOpen(true);
      } else {
        setIsinsclaimOpen(false);
      }
    }
  }, [location?.state?.insclaimopen]);

  useEffect(() => {
    if (location?.state?.insclaimopenfromaccount !== undefined) {
      if (location?.state?.insclaimopenfromaccount === true) {
        setIsinsclaimOpen(true);
      } else {
        setIsinsclaimOpen(false);
      }
    }
  }, [location?.state?.insclaimopenfromaccount]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const step = query.get("step");

    if (
      !(
        location.pathname.includes("patientdashboard") ||
        location.pathname.includes("appointment")
      )
    ) {
      if (step !== "19" && step !== "20" && step !== "21" && step !== "22") {
        dispatch(GetNav("iconopen"));
      } else {
        dispatch(GetNav("iconclose"));
      }
    } else {
      dispatch(GetNav("iconclose")); // force close when in these paths
    }

    if (step === "6.1") {
      setIsIntroOpen(true);

      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    } else if (step === "6.4") {
      setOpenSubMenu("schedule");
      setShowStepFourIntro(true);
      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    }
  }, []);
  // ------------------------------ useEffect----end---------------------------------------------------//

  return (
    <>
      <Nav
        ref={navRef}
        onMouseLeave={handleMouseLeave}
        isopen={isOpen ? "true" : "false"}
        isOnPatientDashboard={isOnPatientDashboard}
        zindex={
          (isOnPatientDashboard && showPatientSubMenu) || isHovered
            ? "1040"
            : Showcontact || showAdd1 || showAdd2
            ? "0"
            : "11"
        }
      >
        <TopIcon>
          {isOpen ? (
            <img
              src={Greaterthanopp}
              alt="Close-icon"
              onClick={handleClose}
              style={{ marginLeft: "135px" }}
            ></img>
          ) : (
            <img
              src={Greaterthan}
              alt="menu-icon"
              onClick={handleMouseEnter}
              style={{ width: "24px" }}
            ></img>
          )}
        </TopIcon>
        <Div display="flex" width="100%" marginLeft={isOpen ? "40px" : "0px"}>
          <NavItem
            isopen={isOpen ? "true" : "false"}
            to="/schedule/nav/1"
            color={
              splitLocation[1] === "schedule" || location.pathname === "/"
                ? globalColor
                : "#2E2E2E80"
            }
            onClick={(e) => {
              if (isOpen) {
                e.preventDefault();
                handleSubMenuClick("schedule");
              }
              handleInputChange1("iconopen");
            }}
          >
            {isOpen ? (
              <>
                <BsCalendar4 strokeWidth="0.5" />
                <Span>Schedule</Span>
              </>
            ) : (
              <>
                <BsCalendar4 strokeWidth="0.5" className="svgSize1" />
                <div style={{ fontSize: "12px" }}>Schedule</div>
              </>
            )}
          </NavItem>
          {isOpen && (
            <Div
              onClick={() => handleSubMenuClick("schedule")}
              cursor="pointer"
              margin="24px 36px 0px auto"
              color={
                splitLocation[1] === "schedule" ||
                (location.pathname === "/" && storedNames.appt)
                  ? globalColor
                  : "#2E2E2E80"
              }
            >
              {openSubMenu === "schedule" ? (
                <FiChevronDown className="svgSize" />
              ) : (
                <FiChevronRight className="svgSize" />
              )}
            </Div>
          )}
        </Div>
        {openSubMenu === "schedule" && (
          <ScheduleNav
            showStepFourIntro={showStepFourIntro}
            setShowStepFourIntro={setShowStepFourIntro}
          />
        )}
        <Div display="flex" width="100%" marginLeft={isOpen ? "40px" : "0px"}>
          <NavItem
            isopen={isOpen ? "true" : "false"}
            to="/patient/nav/1"
            id="pt_nav-lnk_mnu"
            onClick={(e) => {
              if (isOpen) {
                e.preventDefault();
                handleSubMenuClick("patient");
              }
              handleInputChange1("iconopen");
            }}
            color={
              splitLocation[1] === "patient" ||
              (location.pathname === "/" &&
                !storedNames.appt &&
                storedNames.demo)
                ? globalColor
                : "#2E2E2E80"
            }
          >
            {isOpen ? (
              <>
                <FaUsers strokeWidth="0.5" />
                <Span>Patient</Span>
              </>
            ) : (
              <>
                <FaUsers strokeWidth="0.5" />
                <div style={{ fontSize: "12px" }}>Patient</div>
              </>
            )}
          </NavItem>
          {isOpen && (
            <Div
              onClick={() => handleSubMenuClick("patient")}
              cursor="pointer"
              margin="24px 36px 0px auto"
              color={
                splitLocation[1] === "patient" ||
                (location.pathname === "/" &&
                  !storedNames.appt &&
                  storedNames.demo)
                  ? globalColor
                  : "#2E2E2E80"
              }
            >
              {openSubMenu === "patient" ? (
                <FiChevronDown className="svgSize" />
              ) : (
                <FiChevronRight className="svgSize" />
              )}
            </Div>
          )}
        </Div>
        {decryptedPermission.demo && isIntroOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              zIndex: 9999,
            }}
            onClick={() => setIsIntroOpen(false)}
          />
        )}
        {openSubMenu === "patient" && (
          <Div display="flex" width="100%" paddingLeft="0.86em">
            <UL
              textAlign="left"
              width="100%"
              listStyleType="none"
              padding="0"
              margin="0"
              position="relative"
            >
              <ListItem
                ref={servicesRef}
                padding="8px"
                margin="8px 0 0 0"
                onClick={handleInputChange("iconclose")}
                position="relative"
              >
                <Popup
                  offset={[50, 20]}
                  content={
                    <GetStartedPopup
                      title="Patient Engagement"
                      description={
                        <div>
                          Go to Patient {">"} Patient list menu to create &
                          access all of your patient details from the patients
                          list.
                        </div>
                      }
                      currentStep={1}
                      totalSteps={6}
                      onNext={handleIntroNext}
                      onClose={() => setIsIntroOpen(false)}
                      width="320px"
                    />
                  }
                  open={decryptedPermission.demo && isIntroOpen}
                  className="m-t-10"
                  trigger={
                    <SubNavItem
                      to="/patient/patientlist"
                      exact
                      className={`${
                        (splitLocation[1] === "patient" &&
                          splitLocation[2] === "nav") ||
                        splitLocation[2] === "patientlist"
                          ? "active"
                          : ""
                      } ${
                        decryptedPermission.demo && isIntroOpen
                          ? "highlight"
                          : ""
                      }`}
                    >
                      Patients
                    </SubNavItem>
                  }
                  position="left center"
                />
              </ListItem>
              <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem to="/patient/PatientGroup" exact>
                  Patient Group
                </SubNavItem>
              </ListItem>
              <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem to="/patient/BatchEligibility" exact>
                  Batch Eligibility
                </SubNavItem>
              </ListItem>
              <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem to="/patient/patientflag" exact>
                  Patient Flag
                </SubNavItem>
              </ListItem>

              <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem to="/patient/notetaking" exact>
                  Note Taking
                </SubNavItem>
              </ListItem>
              <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem to="/patient/managemacrobutton" exact>
                  Macro Buttons
                </SubNavItem>
              </ListItem>
              <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem to="/patient/patienteducation" exact>
                  Patient Education
                </SubNavItem>
              </ListItem>

              <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem to="/patient/IncomingFax" exact>
                  Incoming Fax
                </SubNavItem>
              </ListItem>
              <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem to="/patient/Outgoingfax" exact>
                  Outgoing Fax
                </SubNavItem>
              </ListItem>
              <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconclose")}
              >
                <SubNavItem to="/patient/electronicreports" exact>
                  Lab Reports
                </SubNavItem>
              </ListItem>

              <ListItem
                padding="8px"
                margin="0"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem to="/patient/referralmanageMent" exact>
                  Referral ManageMent
                </SubNavItem>
              </ListItem>
            </UL>
          </Div>
        )}
        <Div
          display="flex"
          width="100%"
          marginLeft={isinsclaimOpen ? "24px" : isOpen ? "40px" : "0px"}
          // paddingRight={isinsclaimOpen && "40px"}
          ref={highlightinsclaim}
          style={
            decryptedPermission.ins_claims && parseInt(accountType) !== 1
              ? { ...getHighlightStyles(isinsclaimOpen) }
              : {}
          }
        >
          <NavItem
            isopen={isOpen ? "true" : "false"}
            to="/billing/nav/1"
            onClick={(e) => {
              if (isOpen) {
                e.preventDefault();
                handleSubMenuClick("billing");
              }
              handleInputChange1("iconopen");
            }}
            color={
              splitLocation[1] === "billing" ||
              (location.pathname === "/" &&
                !storedNames.appt &&
                !storedNames.demo &&
                storedNames.bill)
                ? globalColor
                : "#2E2E2E80"
            }
          >
            {isOpen ? (
              <>
                <IoWalletOutline strokeWidth="0.5" />
                <Span>Billing</Span>
              </>
            ) : (
              <>
                <IoWalletOutline strokeWidth="0.5" />
                <div style={{ fontSize: "12px" }}>Billing</div>
              </>
            )}
          </NavItem>
          {isOpen && (
            <Div
              onClick={() => handleSubMenuClick("billing")}
              cursor="pointer"
              margin="24px 36px 0px auto"
              color={
                splitLocation[1] === "billing" ||
                (location.pathname === "/" &&
                  !storedNames.appt &&
                  !storedNames.demo &&
                  storedNames.bill)
                  ? globalColor
                  : "#2E2E2E80"
              }
            >
              {openSubMenu === "billing" ? (
                <FiChevronDown className="svgSize" />
              ) : (
                <FiChevronRight className="svgSize" />
              )}
            </Div>
          )}
        </Div>
        {openSubMenu === "billing" && <BillingNav />}
        <Div display="flex" width="100%" marginLeft={isOpen ? "40px" : "0px"}>
          <NavItem
            isopen={isOpen ? "true" : "false"}
            id="rpt_nav-lnk_anch"
            to="/report/nav/1"
            onClick={(e) => {
              if (isOpen) {
                e.preventDefault();
                handleSubMenuClick("report");
              }
            }}
            color={
              splitLocation[1] === "report" ||
              (location.pathname === "/" &&
                !storedNames.appt &&
                !storedNames.demo &&
                !storedNames.bill &&
                storedNames.rep)
                ? globalColor
                : "#2E2E2E80"
            }
          >
            {isOpen ? (
              <>
                <FiFilePlus style={{ color: "inherit" }} />
                <Span>Reports</Span>
              </>
            ) : (
              <>
                <FiFilePlus style={{ color: "inherit" }} />
                <div style={{ fontSize: "12px" }}>Reports</div>
              </>
            )}
          </NavItem>
          {isOpen && (
            <Div
              onClick={() => handleSubMenuClick("report")}
              cursor="pointer"
              margin="24px 36px 0px auto"
              color={splitLocation[1] === "report" ? globalColor : "#2E2E2E80"}
            >
              {openSubMenu === "report" ? (
                <FiChevronDown className="svgSize" />
              ) : (
                <FiChevronRight className="svgSize" />
              )}
            </Div>
          )}
        </Div>
        {openSubMenu === "report" && <ReportNav />}
        <Div display="flex" width="100%" marginLeft={isOpen ? "40px" : "0px"}>
          <NavItem
            isopen={isOpen ? "true" : "false"}
            to="/settings/nav/1"
            onClick={(e) => {
              if (isOpen) {
                e.preventDefault();
                handleSubMenuClick("settings");
              }
              handleInputChange1("iconopen");
            }}
            color={splitLocation[1] === "settings" ? globalColor : "#2E2E2E80"}
            ref={navItemRef}
          >
            {isOpen ? (
              <>
                <FiSettings style={{ color: "inherit" }} />
                <Span>Settings</Span>
              </>
            ) : (
              <>
                <FiSettings style={{ color: "inherit" }} />
                <div style={{ fontSize: "12px" }}>Settings</div>
              </>
            )}
          </NavItem>
          {isOpen && (
            <Div
              onClick={() => handleSubMenuClick("settings")}
              cursor="pointer"
              margin="24px 36px 0px auto"
              color={
                splitLocation[1] === "settings" ? globalColor : "#2E2E2E80"
              }
            >
              {openSubMenu === "settings" ? (
                <FiChevronDown className="svgSize" />
              ) : (
                <FiChevronRight className="svgSize" />
              )}
            </Div>
          )}
        </Div>
        {openSubMenu === "settings" && (
          <SettingsNav
            scrollToTop={scrollToTop}
            setOpenSubMenu={setOpenSubMenu}
            setIsOpen={setIsOpen}
          />
        )}
        <Div marginBottom="80px"></Div>
        {/* Explore Vozo widget */}
        <Div onMouseEnter={exploreMouseEnter} onMouseLeave={exploreMouseLeave}>
          {!isOpen && (
            <Div
              width="24px"
              height="24px"
              backgroundColor={globalColor}
              borderRadius="50%"
              position="absolute"
              bottom="10px"
              left="20px"
            >
              <MdMonitor color="white" />
            </Div>
          )}
          {isHovered && expired_days >= 0 && (
            <ExploreWidget explore="exploreWidgetHover" />
          )}
        </Div>
        {isOpen && <ExploreWidget explore="explore-vozo-widget" />}
      </Nav>
    </>
  );
};

export default SideNav;
